import { gql, useQuery } from '@apollo/client';

export const GET_EMPLOYEE_BY_ID = gql`
  query getMemberById($memberId: ObjectId!) {
    getMemberById(memberId: $memberId) {
      _id
      documentsIds
      createdBy
      profile {
        firstName
        lastName
        gender
        companyPhoneNumber
        cityOfBirth
        countryOfBirth
        salutation
        birthName
        phoneNumber
        personalEmail
        birthday
        nationality
        socials {
          linkedIn
          xing
        }
        address {
          zipCode
          country
          city
          street
          houseNumber
        }
        avatarUrl
      }
      account {
        email
        active
        permissionGroup
        permissionGroupId
      }
      employeePersonalInfo {
        status
        internalNumber
        employeeNumber
        preface
        academicDegree
        accessToPlatform
      }
      paymentAndInsurance {
        bankAccountHolder
        iban
        bic
        typeOfVisa
        taxId
        visaExpirationDate
        nationalInsuranceNumber
        healthInsuranceType
        healthInsuranceId
        workPermissionNeeded
        hasCertificateOfStudy
        residencePermissionNeeded
        workPermissionExpireDate
        residencePermissionExpireDate
        certificateOfStudyExpireDate
      }
      emergencyContact {
        name
        phoneNumber
        relationship
        firstAider
        maritalStatus
        childAllowance
      }
      educationAndSkills {
        schoolName
        schoolEducationDescription
        universityName
        universityEducationDescription
        furtherName
        furtherEducationDescription
        trainingName
        trainingDescription
        driversLicenses
        driversLicensesDescription
        highestTrainingDegree
        skills {
          name
          description
        }
      }
      healthInsurance {
        name
        _id
      }
    }
  }
`;

export const useGetEmployeeById = (memberId: string) => {
  const { data, loading } = useQuery(GET_EMPLOYEE_BY_ID, {
    variables: {
      memberId,
    },
    fetchPolicy: 'network-only',
    skip: !memberId,
  });

  const employee = data?.getMemberById || {};

  return { employee, loading };
};
